import { Keyframes } from '@ant-design/cssinjs';
var antShowHelpIn = new Keyframes('antShowHelpIn', {
    '0%': {
        transform: 'translateY(-5px)',
        opacity: 0,
    },
    to: {
        transform: ' translateY(0)',
        opacity: 1,
    },
});
export var getAnimationStyle = function (token) {
    var _a;
    var componentCls = token.componentCls;
    var helpCls = "".concat(componentCls, "-help");
    return _a = {},
        _a[helpCls] = {
            '&-appear, &-enter': {
                animationDuration: '0.3s',
                animationFillMode: 'both',
                animationPlayState: 'paused',
                opacity: 0,
                animationTimingFunction: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
                '&-active': {
                    animationPlayState: 'running',
                    animationName: antShowHelpIn,
                },
            },
        },
        _a;
};
//# sourceMappingURL=animation.js.map